/**
 * Shared empty-state — icon chip + title + message + optional CTA, so "no data
 * yet" screens look the same across features (they were ad-hoc: some a boxed
 * card with icon, some a bare line).
 */

import type { LucideIcon } from "lucide-react";
import type { ReactNode } from "react";

import { ICON_STROKE } from "@/shared/components/icons";

export function EmptyState({
  Icon,
  title,
  message,
  action,
}: {
  Icon?: LucideIcon;
  title: string;
  message?: ReactNode;
  /** A CTA (button or link) rendered under the message. */
  action?: ReactNode;
}) {
  return (
    <section className="rounded-2xl border border-border bg-surface p-6 text-center space-y-4">
      {Icon && (
        <div className="mx-auto w-12 h-12 rounded-full bg-accent/15 flex items-center justify-center">
          <Icon size={24} strokeWidth={ICON_STROKE} className="text-accent" />
        </div>
      )}
      <div>
        <h2 className="text-lg font-semibold text-text">{title}</h2>
        {message && (
          <p className="mt-1.5 text-sm text-text-muted leading-relaxed">{message}</p>
        )}
      </div>
      {action}
    </section>
  );
}
